import React from 'react'
import Header from '../../../components/Dashboard/Header'
import EditProfilecard from '../../../components/Dashboard/Innovator/profile/EditProfilecard'

function EditProfile() {
  return (
    <div className='overflow-x-hidden  flex flex-col relative bg-[#F3F4FF]'>
      <Header />
      <EditProfilecard />
      </div>
  )
}

export default EditProfile